// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__xIDcR","dragIcon":"SortableItem_dragIcon__36jAw","disabled":"SortableItem_disabled__1EwxJ"};